import React from "react";

/**
 * HP Theme - Logo Icon
 * Official HP logo with white circular background
 */
interface HpLogoIconProps {
  width?: number;
  height?: number;
}

export const HpLogoIcon = ({ width = 42, height = 42 }: HpLogoIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_26_11649)">
        <path
          d="M21 0C9.40118 0 0 9.40222 0 21C0 32.5978 9.40118 42 21 42C32.5988 42 42 32.5983 42 21C42 9.4017 32.5988 0 21 0Z"
          fill="white"
        />
        <path
          d="M21.0005 40.4501C20.8067 40.4501 20.6141 40.4465 20.4224 40.4412L24.3972 29.517H29.8672C30.8269 29.517 31.8816 28.7789 32.2092 27.8774L36.5216 16.0319C37.2266 14.0925 36.1163 12.506 34.0525 12.506H26.4636L20.0964 30.0037H20.0938L16.4839 39.922C7.92061 37.8855 1.55078 30.188 1.55078 21.0005C1.55078 11.813 7.55836 4.56008 15.7489 2.26846L12.0235 12.5054L5.83006 29.516H9.95236L15.2181 15.0611H18.3156L13.0499 29.516H17.1701L22.0778 16.0308C22.7839 14.0915 21.6725 12.5049 19.6113 12.5049H16.1463L20.1263 1.57126C20.4161 1.55866 20.707 1.55078 21.0005 1.55078C31.742 1.55078 40.4501 10.259 40.4501 21.0005C40.4501 31.742 31.742 40.4501 21.0005 40.4501ZM32.7683 15.0522H29.6719L25.3343 26.9524H28.4318L32.7683 15.0522Z"
          fill="#024AD8"
        />
      </g>
      <defs>
        <clipPath id="clip0_26_11649">
          <rect width="42" height="42" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
